"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatNewIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ChatNew_svg_1 = __importDefault(require("./ChatNew.svg"));
/**
 * New Chat Icon
 */
function ChatNewIcon() {
    return (0, jsx_runtime_1.jsx)(ChatNew_svg_1.default, {});
}
exports.ChatNewIcon = ChatNewIcon;
//# sourceMappingURL=index.js.map